export const base64StringCleanUp = async (
  base64String: string
): Promise<string> => {
  const base64StringCleanUp = base64String.replace(
    /^data:image\/\w+;base64,/,
    ''
  );
  return base64StringCleanUp.trim();
};

// am not sure if this is the best way to do it, or right place , but for now it works
export function getFileTypeFromBase64(
  base64String?: string | null
): string | null {
  if (!base64String) return null;
  const s = base64String.trim();

  if (s.startsWith('data:application/pdf')) return '.pdf';

  const imgMatch = s.match(/^data:image\/([a-zA-Z0-9.+-]+);base64,/);
  if (imgMatch && imgMatch[1]) {
    const mime = imgMatch[1].toLowerCase();
    if (mime === 'jpeg' || mime === 'jpg') return '.jpg';
    if (mime === 'png') return '.png';
    if (mime === 'gif') return '.gif';
    if (mime === 'webp') return '.webp';
    return `.${mime}`;
  }
  return null;
}
export default getFileTypeFromBase64;
